import React from 'react';
import { cn } from '@/lib/utils';
import ResponsiveWrapper from '@/components/layout/ResponsiveWrapper';
import Wrapper from '@/components/layout/Wrapper';
import { PRESET_RATIO } from './consts';
import type { AspectRatioProps } from './types';

function AspectRatio({
  asChild,
  presetRatio,
  responsive = {},
  className,
  children,
}: AspectRatioProps) {
  const classes = cn(
    'w-full',
    PRESET_RATIO[presetRatio as keyof typeof PRESET_RATIO],
    className,
  );

  return (
    <ResponsiveWrapper responsive={responsive}>
      <Wrapper asChild={asChild} className={classes}>
        {children}
      </Wrapper>
    </ResponsiveWrapper>
  );
}

export default React.memo(AspectRatio);
